import FillBlanks from "../../components/ClassOne/EnvironmentScience/Animals/FillBlanks";
import MultipleChoice from "../../components/ClassOne/EnvironmentScience/Animals/MultipleChoice";
import OddOneOut from "../../components/ClassOne/EnvironmentScience/Animals/OddOneOut";
import TrueFalse from "../../components/ClassOne/EnvironmentScience/Animals/TrueFalse";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-one/environmental-science/animals/fill-blanks", title: "Fill in the Blanks", component: FillBlanks },
    { url: "/class-one/environmental-science/animals/odd-out", title: "Odd One Out", component: OddOneOut },
    { url: "/class-one/environmental-science/animals/true-false", title: "True or False", component: TrueFalse },
    { url: "/class-one/environmental-science/animals/multiple-choice-question", title: "Multiple Choice Questions", component: MultipleChoice },
];

export default topics;